/* eslint-disable max-len */
const React = require('react');

const Argencard = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="svelte-i8fx49 medium-32R5CW"><path d="M7.40284 15.2373H15.8389L13.09 18.8392C4.93835 19.6919 2 16.2801 2 11.5406C2 9.17841 4.36963 5 11.9526 5C19.2512 5.00019 22 9.06822 22 11.5406V18.8392H16.8815V9.07618H7.40284V15.2373Z" fill="#E91D28" /></svg>
);

module.exports = Argencard;
